export default "__VITE_ASSET__32537704__"